import React, { } from 'react';


function Dashboard() {

    return (
        <div className='text-center rounded-2xl px-10 py-20'>
            <div className='max-w-sm mx-auto'>
                <img src="/img/svgs/dashboard-nothing.svg" className='inline-block w-36' alt="No data for dashboard" />
                <h2 className='text-3xl pt-8 mb-3'>Nothing For Dashboard</h2>
                <p>Suggest something to the team to put here. Your suggestions are very much welcomed.</p>
            </div>
        </div>
    );
}


export default Dashboard;